<template>
  <div class="buy-component">
    <transition name="fadeFast" mode="out-in">
      <PaySPB
        v-if="showModalPaySPB"
        :titleWindow="'Оплата курса'"
        :qrImage="qrImage"
        :idOrder="idSPBPay"
        @closeModal="closeModal()"
        key="paySPB"
      ></PaySPB>

      <PatternModalWindow
        v-else
        id="buy-course"
        :titleWindow="'Оплата курса'"
        @closeModal="closeModal()"
        key="default"
      >
        <transition name="fade">
          <ModalNotification
            v-if="showModuleNotification"
            :timeShowNotification="modalNotification.time"
            :textNotification="modalNotification.text"
            :typeNotification="modalNotification.type"
            @close="closeModuleNotification"
          >
          </ModalNotification>
        </transition>

        <transition name="fadeFast" mode="out-in">
          <div class="main_info installment_component"
               v-if="openedModalInstallment"
               key="installment_component"
          >
            <div class="text text__h3"
                 v-if="installmentData.list && installmentData.list.length === 1"
            >
              На покупку данного курса доступна рассрочка сроком на {{ getMonthInstallment }}
            </div>

            <div class="text text__h3"
                 v-else
            >
              Выберите количество месяцев, на которую хотите получить рассрочку
            </div>

            <div class="input-wrapper">
              <div class="input-wrapper_header">
                <div class="block block__column">
                  <div class="text text__additional">
                    Срок:
                  </div>

                  <div class="text text__h4">
                    {{ getMonthInstallment }}
                  </div>
                </div>

                <div class="block block__column">
                  <div class="text text__additional">
                    Ежемесячный платеж:
                  </div>

                  <div class="text text__h4">
                    {{ '≈ ' + getSumInstallment + ' ₽' }}
                  </div>
                </div>
              </div>

              <div class="input-wrapper_border"></div>

              <div class="input-wrapper_main">
                <div class="list-values"
                     :class="{'list-values__center': installmentData.list && installmentData.list.length === 1}"
                >
                  <div class="item"
                       :class="{'item__purple': (i + 1) === Number(installmentData.selectedMonth)}"
                       v-for="(item, i) in installmentData.list"
                       :key="'month_' + item.id"
                  >
                    <div class="text text__number">
                      {{ item.term }}
                    </div>
                  </div>
                </div>

                <div class="input-wrapper_content">
                  <div class="input-bar">
                    <div class="bar"
                         :style="{width: barPosition}"
                    ></div>
                  </div>

                  <div class="input-box input-box__theme_range-hidden"
                       :class="{'input-box__theme_disable': installmentData.list && installmentData.list.length === 1}"
                  >
                    <input id="input-default-range"
                           type="range"
                           :min="installmentData.min"
                           :max="installmentData.max"
                           v-model="installmentData.selectedMonth"
                    />
                  </div>

                  <div class="input-box input-box__theme_range-custom"
                       id="input-box__theme_range-custom"
                  >
                    <div class="block block__theme_separator"
                         :style="{left: calcSeparatorPosition}"
                    >
                      <div class="separator_desktop">
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M2.24994 14.2504H15.7499C15.8866 14.25 16.0206 14.2123 16.1374 14.1414C16.2543 14.0705 16.3496 13.9691 16.4131 13.848C16.4766 13.727 16.5059 13.5909 16.4978 13.4545C16.4897 13.318 16.4445 13.1864 16.3672 13.0737L9.61719 2.3237C9.33744 1.91945 8.66394 1.91945 8.38344 2.3237L1.63344 13.0737C1.55531 13.1862 1.50949 13.3179 1.50097 13.4545C1.49244 13.5912 1.52153 13.7276 1.58508 13.8489C1.64863 13.9702 1.7442 14.0718 1.86142 14.1426C1.97863 14.2133 2.11301 14.2507 2.24994 14.2504Z"
                            fill="#8C71FE"/>
                        </svg>
                      </div>

                      <div class="separator_mobile"></div>
                    </div>

                    <div class="block block__theme_range"
                         v-if="installmentData.list && installmentData.list.length === 1"
                    >
                      <div class="line"
                           :class="{'line__theme_large': i === 5}"
                           v-for="(item, i) in 11"
                           :key="'line-container_' + item"
                      ></div>
                    </div>

                    <div class="block block__theme_range"
                         v-else
                    >
                      <div class="line"
                           :class="{'line__theme_large': (i % 5) === 0}"
                           v-for="(item, i) in getProgressLineLength"
                           :key="'line-container_' + item"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="check_contract">
              <input type="checkbox"
                     class="check_contract_checkbox"
                     name="input_tutor"
                     :id="'check_contract'"
                     v-model="isCheckContact"
                     @change="checkContract()"
              >
              <label :for="'check_contract'" class="label_block">
            <span class="text_label">
               Я даю свое согласие на
              <router-link :to="{name: 'personalData', params: {}}" target="_blank">
                обработку персональных данных
              </router-link> и принимаю
              <router-link :to="{name: nameContractPage, params: {}}" target="_blank">
                условия Оферты
              </router-link>
            </span>
                <transition name="fade">
                  <div class="notifications error" v-if="notifications.check !== ''">
                    {{ notifications.check }}
                    <div class="notifications_square">
                    </div>
                  </div>
                </transition>
              </label>
            </div>

            <div class="management">
              <div class="button button__theme_light-purple"
                   @click="goBack()"
              >
                Вернуться назад
              </div>

              <div class="button button__theme_purple"
                   :class="{'button__theme_disable': !active_button.active}"
                   @click="buyInInstallments()"
              >
                Оформить рассрочку
              </div>
            </div>
          </div>

          <div class="main_info"
               id="modal_buy_course"
               key="modal_buy_course"
               v-else
          >
            <div class="text_block">
              Привяжите свой аккаунт ВКонтакте, чтобы иметь возможность общаться с кураторами и репетиторами. А также
              введите свою почту, на нее придет чек после оплаты.
            </div>

            <div class="input_grid">
              <div class="inputBlock">
                <div class="inputBlock_title">
                  Ссылка на ВКонтакте
                </div>
                <div class="inputBlock_input"
                     :class="(notifications.vk !== '')?('errorNotifications'):('')"
                >
                  <input
                    type="text"
                    placeholder="Тут появится ссылка после привязки аккаунта"
                    v-model="vk"
                    class="input input__theme_disabled"
                    :class="{
                    'input__theme_valid': vk !== '',
                    'input__theme_disabled': vk !== '',
                    'input__theme_invalid': vk === '' && notifications.vk !== '',
                  }"
                    disabled
                  >
                  <div class="input_logo" v-if="vk !== ''">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M9.80026 14.3095L6.60007 11.1093L6.50726 11.0165L6.41445 11.1093L5.00045 12.5233L4.90765 12.6161L5.00045 12.709L9.70745 17.416L9.80026 17.5088L9.89307 17.416L19.6001 7.70896L19.6929 7.61615L19.6001 7.52334L18.1861 6.10934L18.0933 6.01653L18.0005 6.10934L9.80026 14.3095Z"
                        fill="#89CE54" stroke="#89CE54" stroke-width="0.2625"/>
                    </svg>
                  </div>
                  <transition name="fade">
                    <div class="notifications error" v-if="notifications.vk !== ''">
                      {{ notifications.vk }}
                      <div class="notifications_square">
                      </div>
                    </div>
                  </transition>
                </div>
              </div>

              <div class="vk_button_block"
                   :class="{'vk_button_block__mobile_disable': vk !== ''}"
              >
                <transition name="fade">
                  <button class="vk_button"
                          v-if="dataReceived && ((vk === '') || (notifications.vk !== ''))"
                          @click="logInVk()"
                  >
                    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M25.1757 7.94033C25.339 7.39783 25.1757 7 24.4033 7H21.8448C21.1938 7 20.8963 7.34417 20.733 7.72217C20.733 7.72217 19.4322 10.8943 17.5888 12.9512C16.9938 13.5497 16.722 13.7387 16.3977 13.7387C16.2355 13.7387 15.9998 13.5497 15.9998 13.0072V7.94033C15.9998 7.28933 15.812 7 15.2695 7H11.2492C10.8432 7 10.5982 7.301 10.5982 7.588C10.5982 8.204 11.5198 8.34633 11.6143 10.0823V13.8483C11.6143 14.6732 11.4662 14.8237 11.1395 14.8237C10.2727 14.8237 8.16333 11.6398 6.9115 7.99517C6.66766 7.287 6.4215 7.00117 5.76816 7.00117H3.21083C2.47933 7.00117 2.3335 7.34533 2.3335 7.72333C2.3335 8.40233 3.20033 11.7623 6.37133 16.2062C8.48533 19.2407 11.4615 20.8857 14.1728 20.8857C15.798 20.8857 15.9987 20.5205 15.9987 19.8905V17.5968C15.9987 16.8665 16.1538 16.7195 16.6683 16.7195C17.0463 16.7195 17.6973 16.9108 19.2152 18.3727C20.9488 20.1063 21.2358 20.8845 22.21 20.8845H24.7673C25.4977 20.8845 25.8628 20.5193 25.6528 19.7983C25.423 19.0808 24.5947 18.0367 23.4957 16.8012C22.8983 16.0965 22.0058 15.3382 21.734 14.959C21.3548 14.4702 21.4645 14.2543 21.734 13.8203C21.7352 13.8215 24.8513 9.4325 25.1757 7.94033Z"
                        fill="white"/>
                    </svg>
                    <div class="vk_button_text">
                      Привязать аккаунт
                    </div>
                  </button>
                </transition>
              </div>

              <div class="inputBlock">
                <div class="inputBlock_title">
                  Почта
                </div>
                <div class="inputBlock_input"
                     :class="(notifications.mail !== '')?('errorNotifications'):('')"
                >
                  <input type="text"
                         id="mail"
                         placeholder="Введите почту"
                         v-model="mail"
                         value="mail"
                         class="input input__theme_email"
                         :class="{
                        'input__theme_valid': disabledMail,
                        'input__theme_invalid': notifications.mail !== '',
                      }"
                         :disabled="disabledMail"
                         @input="getMail()"
                         @blur="inputMail()"
                  >
                  <div class="input_logo" v-if="disabledMail">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M9.80026 14.3095L6.60007 11.1093L6.50726 11.0165L6.41445 11.1093L5.00045 12.5233L4.90765 12.6161L5.00045 12.709L9.70745 17.416L9.80026 17.5088L9.89307 17.416L19.6001 7.70896L19.6929 7.61615L19.6001 7.52334L18.1861 6.10934L18.0933 6.01653L18.0005 6.10934L9.80026 14.3095Z"
                        fill="#89CE54" stroke="#89CE54" stroke-width="0.2625"/>
                    </svg>
                  </div>
                  <transition name="fade">
                    <div class="notifications error" v-if="notifications.mail !== ''">
                      {{ notifications.mail }}
                      <div class="notifications_square">
                      </div>
                    </div>
                  </transition>
                </div>
              </div>
            </div>

            <div class="inputBlock inputBlock__theme_pays">
              <div class="inputBlock_title">
                Как и чем оплачивать*
              </div>
              <div class="block block__theme_grid">
                <div class="block block__theme_card-container block__theme_pay-list-container">
                  <div class="block block__theme_card block__theme_pay-list"
                       :class="{'block__theme_pay-list_active': showListPaymentOptions}"
                       @click="changeVisibilityListPaymentOptions"
                  >
                    <div class="block block__row">
                      <div class="svg svg__theme_logo"
                           v-html="paymentOptions[indexActivePaymentOptions].svg"
                      ></div>

                      <div class="text">
                        {{ paymentOptions[indexActivePaymentOptions].title }}
                      </div>
                    </div>

                    <div class="block block__row block__svg_arrow">
                      <div class="svg svg__theme_arrow">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M17.2656 9L12 13.8229L6.73436 9L5 10.5885L12 17L19 10.5885L17.2656 9Z"
                                fill="#B1A1F2"/>
                        </svg>
                      </div>
                    </div>
                  </div>

                  <transition name="fade">
                    <div class="list"
                         v-if="showListPaymentOptions"
                    >
                      <div class="elem"
                           :class="{'elem__disabled': !item.available}"
                           v-for="(item, i) in paymentOptions"
                           :key="'pay_' + item.id"
                           @click="selectPaymentOption(item, i)"
                      >
                        <div class="svg"
                             v-html="item.svg"
                        ></div>
                        <div class="text">
                          {{ item.title }}
                        </div>
                      </div>
                    </div>
                  </transition>
                </div>

                <div class="block block__theme_card-container">
                  <div class="block block__theme_card block__theme_credit"
                       :class="{'block__theme_disabled': !paymentData.isAccessCredit}"
                       @click="installmentPay()"
                  >
                    <div class="block block__row">
                      <div class="svg"
                           v-html="svgTinkoff"
                      ></div>

                      <div class="text">
                        Рассрочка 0% от банков партнёров
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <InputComponent
              class="inputBlock__theme_pays telephone-input-component"
              :type="'telephone'"
              :title="'Телефон'"
              :placeholder="'+7'"
              v-model:value="telephone.value"
              :textHint="telephone.hint.text"
              :showHint="telephone.hint.show"
              :enableHintModal="telephone.hint.enableModal"
              :textHintModal="telephone.hint.textModal"
            ></InputComponent>

            <div class="check_contract">
              <input type="checkbox"
                     class="check_contract_checkbox"
                     name="input_tutor"
                     :id="'check_contract'"
                     v-model="isCheckContact"
                     @change="checkContract()"
              >
              <label :for="'check_contract'" class="label_block">
            <span class="text_label">
               Я даю свое согласие на
              <router-link :to="{name: 'personalData', params: {}}" target="_blank">
                обработку персональных данных
              </router-link> и принимаю
              <router-link :to="{name: nameContractPage, params: {}}" target="_blank">
                условия Оферты
              </router-link>
            </span>
                <transition name="fade">
                  <div class="notifications error" v-if="notifications.check !== ''">
                    {{ notifications.check }}
                    <div class="notifications_square">
                    </div>
                  </div>
                </transition>
              </label>
            </div>

            <button class="button button__theme_pay"
                    :class="{'button__theme_disable': !active_button.active || !telephoneIsCorrect}"
                    @click="payCourse()"
            >
              {{ 'Оплатить ' + paymentData.priceText + ' ₽' }}
            </button>
          </div>
        </transition>
      </PatternModalWindow>
    </transition>
  </div>
</template>

<script>
import PaySPB from "../../../DefaultComponents/ModalWindows/PaySPB";
import ModalNotification from '../../../DefaultComponents/ModalWindows/ModalNotification';
import PatternModalWindow from "../../../DefaultComponents/ModalWindows/PatternModalWindow";
import InputComponent from "@/components/DefaultComponents/Inputs/InputComponent";
import tinkoff from '@tcb-web/create-credit';
import {send} from "../../../fetchData";
import {emitter} from '../../../databus';
import {imagePaymentOptions} from "@/svgStoreFiles";

import {connectPayment} from '@/helpers/pay/connection/connectionCloudPayments';
import {pay as payGKMethod} from "@/helpers/pay/methods/payMethodGK";
import {pay as payFinalEssayMethod} from "@/helpers/pay/methods/payMethodFinalEssay";
import {pay as payPGKMethod} from "@/helpers/pay/methods/payMethodPGK";
import {checkClickOutside} from "@/helpers/events/clickOutside";
import {getMoscowTime} from "@/helpers/time/time";
import {pay as payOrder} from "@/helpers/pay/methods/payOrder";
import {getDescription} from "@/helpers/pay/helpers";
import {installmentPayVsegdaDa} from "@/helpers/pay/methods/payVsegdaDa";

export default {
  name: "modalBuyCourse",
  props: {
    vk_is_used: {
      type: String,
      default: ''
    },

    paymentData: { // данные для оплат
      type: Object,
      default: () => {
        return {}
      }
    },

    isOldVersion: { // это старая стр. оплат?
      type: Boolean,
      default: false,
    },

    nextRoute: { // путь редиректа при успешной оплате
      type: String,
      default: null,
    },

    runSuccessfullyPayFunc: { // // запустить ли функцию успешной оплаты при открытии модального окна покупки курсов? Используется при оплате через Yandex Pay
      type: Boolean,
      default: false,
    },

    installment: { // данные по рассрочкам
      type: Object,
      default: () => {
        return {
          id: null, // идентификатор заказа
          showcaseId: '',
          shopId: '',
          orderId: '',
          min: 1,
          max: null,
          selectedMonth: 1,
          list: [], // список промокодов (месяцев) для рассрочек
          amount: null, // стоимость
        }
      }
    },
  },
  data() {
    return {
      typePage: '', // тип страницы / gk - гк / ff - огненное итоговое сочинение
      nameContractPage: '', // имя для страницы с офертой
      dataReceived: false, // данные от апи получены?
      enableCloseModal: false, // разрешить закрыть модальное окно?
      qrImage: '', // изображение qr кода оплаты
      idSPBPay: undefined, // id оплаты через СПБ
      notifications: {
        vk: '',
        mail: '',
        check: ''
      },
      showModalPaySPB: false, // отобразить модальное окно с оплатой через СПБ
      vk: '',
      mail: '',
      isCheckContact: false,
      showModuleNotification: false,
      disabledMail: false,
      active_button: {
        vk: false,
        mail: false,
        check: false,
        active: false,
      },
      modalNotification: {
        time: null,
        text: null,
        type: null
      },

      openedModalInstallment: false, // открыто модальное окно выбора периода рассрочки
      svgTinkoff: imagePaymentOptions.tinkoffLogo,
      indexActivePaymentOptions: 0, // index активного варианта оплаты
      showListPaymentOptions: false, // отобразить выпадающий список
      paymentOptions: [
        {
          id: 0,
          typePay: 'spb',
          title: 'Система быстрых платежей',
          svg: imagePaymentOptions.sqp,
          available: true, // данный вариант доступен для выбора?
        },
        {
          id: 1,
          typePay: 'card',
          title: 'Банковская карта',
          svg: imagePaymentOptions.card,
          available: true, // данный вариант доступен для выбора?
        },
        {
          id: 2,
          typePay: 'yandex',
          title: 'Yandex Pay: сразу или частями',
          svg: imagePaymentOptions.card,
          available: true, // данный вариант доступен для выбора?
        },
      ],

      barPosition: '0%', // позиция bar

      telephone: { // Телефон
        value: '',
        hint: {
          text: 'Зачем указывать номер телефона?',
          show: true,
          enableModal: true,
          textModal: 'Для подтверждения вашей личности при оплате через push-уведомление или SMS необходим номер телефона',
        }
      },
    }
  },

  created() {
    setTimeout(() => {
      this.enableCloseModal = true;
    }, 500);

    this.getData();
    connectPayment(); // функция подключения метода оплаты

    emitter.on('TinkoffSBPPay', this.SBPPayResult);
    console.log('paymentData', this.paymentData);
  },

  mounted() {
    let elemModal = document.getElementById('modal_buy_course');
    if (elemModal) elemModal.addEventListener('click', this.closeListPaymentOptions);

    window.onresize = (event) => {
      if (this.openedModalInstallment) this.calcBarPosition(); // расчет позиции bar
    };

    if (this.vk_is_used === "invalid_vk_is_used") {
      this.showModuleNotification = true;
      this.modalNotification.time = 6;
      this.modalNotification.text = 'Данный аккаунт ВКонтакте привязан к другой учетной записи';
      this.modalNotification.type = 'error';   // successfully / error
    }

    if (this.runSuccessfullyPayFunc) this.successBuyCourse();
    // this.presetInstallmentData();

    tinkoff.methods.on(tinkoff.constants.SUCCESS, this.onTinkoffMessage);
    tinkoff.methods.on(tinkoff.constants.REJECT, this.onTinkoffMessage);
    tinkoff.methods.on(tinkoff.constants.CANCEL, this.onTinkoffMessage);
  },

  beforeUnmount() {
    let elemModal = document.getElementById('modal_buy_course');
    if (elemModal) elemModal.removeEventListener('click', this.closeListPaymentOptions);
  },

  watch: {
    active_button: {
      handler(val) {
        if (this.active_button.vk === true &&
          this.active_button.mail === true &&
          this.active_button.check === true
        ) {
          this.active_button.active = true
        } else if (
          this.active_button.vk === false ||
          this.active_button.mail === false ||
          this.active_button.check === false
        ) {
          this.active_button.active = false
        }
      },
      deep: true
    },

    'installmentData.selectedMonth'(after) {
      this.calcBarPosition(); // расчет позиции bar
    }
  },

  methods: {
    getData() {
      console.log('--- getData ---');

      this.isSummerSchool = this.$store.state.allCourses[this.paymentData.idCourse]?.aliasCourse.indexOf('summer') !== -1;
      switch (this.$store.state.allCourses[this.paymentData.idCourse].type) {
        case 'pgk': // ПГК
          console.log('--- 1 ---');
          this.nameContractPage = 'contractPGK';
          this.typePage = 'pgk';
          this.isCheckContact = this.$store.state.auth.other.is_accept_contract_semi_gk ?? false;
          break;

        case 'ff': // Огненное итоговое
          console.log('--- 2 ---');
          this.nameContractPage = 'contractEssay';
          this.typePage = 'ff';
          break;

        default:
          console.log('--- 3 ---');
          this.nameContractPage = (this.paymentData.idExam === 7) ? ('contractAcademy') : ('contract');
          this.typePage = 'gk';
          this.isCheckContact = this.$store.state.auth.other.is_accept_contract ?? false;
      }


      console.log('--- 99 ---');

      let data = {
        module: 'get_profile_info',
        course_id: 1
      }

      send
        .post("user.php", data)
        .then((response) => {

          this.dataReceived = true;
          this.mail = response.info.email
          if (
            String(this.mail.trim())
              .toLowerCase()
              .match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
              ) !== null
          ) {
            this.active_button.mail = true
            this.disabledMail = true
          } else {
            this.active_button.mail = false
            this.disabledMail = false
            this.mail = ''
          }

          this.vk = (response.info.vk_id === null) ? ('') : ('https://vk.com/id' + response.info.vk_id)

          console.log('this.vk', this.vk);

          this.active_button.vk = response.info.vk_id !== null;
          this.active_button.check = this.isCheckContact;
        })
        .catch((error) => {
          console.log(error)
        })
    },


    getMail() {
      if (
        String(this.mail.trim())
          .toLowerCase()
          .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          ) !== null
      ) {
        this.active_button.mail = true
      } else {
        this.active_button.mail = false
      }
    },
    closeModal() {
      if (this.enableCloseModal) this.$emit("close");
    },
    logInVk() {
      // https://ri-ege.ru/lk/gk/ege/gk/buy/subject/6167/tariff
      let url = `https://ri-ege.ru/lk/gk/buyCourse/${ this.paymentData.idCourse }/selectTariff?type=open_modal&idTariff=${ this.paymentData.idStock }&typeTutor=${ this.paymentData.activeTypeTutor }`

      document.location.href = "https://oauth.vk.com/authorize?client_id=6660888&display=page&redirect_uri=https://ri-ege.ru/lk/2021/service/verify_vk2.php&scope=,offline&response_type=code&v=5.80&state=" + btoa(url);
    },
    inputMail() {
    },
    checkContract() {
      this.active_button.check = this.isCheckContact;

      // принять контракт
      let acceptContract = (module, file) => {
        return new Promise((resolve, reject) => {
          send
            .post(file, {
              module: module
            })
            .then((response) => {
              console.log("Success", response);
              resolve(response);
            })
            .catch((error) => {
              console.log("error", error);
              reject(error);
            })
        })
      };

      if (this.isCheckContact) {
        switch (this.typePage) {
          case 'pgk':
            acceptContract('accept_contract_semi_gk', 'user.php').then(result => {
              console.log("Success")
            })
            break;

          default:
            acceptContract('accept_contract', 'user.php').then(result => {
              console.log("Success")
            })
        }
      }
    },

    closeModuleNotification() {
      this.showModuleNotification = false
    },

    // принять и скрыть модальное окно подтверждение согласия с польз. соглашением
    applyPaymentAgreement() {
      let data = {
        module: 'accept_contract'
      };

      send
        .post('user.php', data)
        .then((response) => {
          console.log('соглашение успешно принято');
        })
        .catch((error) => {
          console.log('error api cookies');
          console.log(error.response)
        })
    },

    // сменить видимость модального окна с выбором варианта оплаты
    changeVisibilityListPaymentOptions() {
      this.showListPaymentOptions = !this.showListPaymentOptions;
    },

    // закрыть модальное окно с выбором варианта оплаты
    closeListPaymentOptions($event) {
      if (this.showListPaymentOptions && checkClickOutside($event, 'DIV', 'block__theme_pay-list-container')) {
        this.showListPaymentOptions = false;
      }
    },

    // выбрать вариант оплаты
    selectPaymentOption(item, index) {
      if (!item.available) return false;
      if (this.showListPaymentOptions) this.showListPaymentOptions = false;
      this.indexActivePaymentOptions = index;
    },

    /** Покупка через рассрочку
     * */
    installmentPay() {
      installmentPayVsegdaDa(this.paymentData.idOrder, [this.paymentData.idCourse]);
    },

    // открыть модальное окно с получением рассрочки
    openModalInstallment() {
      if (this.paymentData.isAccessCredit) {
        this.openedModalInstallment = true;

        setTimeout(() => {
          this.calcBarPosition();
        }, 500);
      } else {
        emitter.emit('openGlobalNotifications', {
          show: true,
          time: 4,
          text: 'На данном тарифе рассрочка недоступна',
          type: 'error'
        })
      }
    },

    payCourse() {
      let checkError = false;

      if (this.active_button.vk === false) {
        checkError = true;
        this.showModuleNotification = true;
        this.modalNotification.time = 6;
        this.modalNotification.text = 'Привяжите аккаунт ВКонтакте';
        this.modalNotification.type = 'error';   // successfully / error
      }

      if (this.active_button.mail === false) {

        if (this.showModuleNotification && checkError) {
          this.modalNotification.text += ' и введите почту';
        } else {
          this.showModuleNotification = true;
          this.modalNotification.time = 6;
          this.modalNotification.text = 'Введите корректный адрес электронной почты';
          this.modalNotification.type = 'error';   // successfully / error
        }

        checkError = true;
      }

      if (this.active_button.check === false) {
        checkError = true;

        if (!this.showModuleNotification) {
          this.showModuleNotification = true;
          this.modalNotification.time = 6;
          this.modalNotification.text = 'Дайте согласие на обработку персональных данных';
          this.modalNotification.type = 'error';   // successfully / error
        }
      }

      if ( !this.telephoneIsCorrect ) {
        checkError = true;

        if (!this.showModuleNotification) {
          this.showModuleNotification = true;
          this.modalNotification.time = 6;
          this.modalNotification.text = 'Введите корректный номер телефона';
          this.modalNotification.type = 'error';   // successfully / error
        }
      }

      if (!checkError) {
        switch (this.paymentOptions[this.indexActivePaymentOptions].typePay) {
          case 'card': // отплата картой
            this.cardPay();
            break;

          case 'spb': // оплата через СПБ
             this.showSPBPay();
            break;

          case 'yandex': // оплата через yandex
            this.yandexPay();
            break;
        }
      }
    },

    /** Оплата через Яндекс Pay
     * */
    yandexPay() {
      /** Инициализировать оплату и получить ссылку редиректа
       */
      let apiGetPayLink = (successURL, failURL) => {
        return new Promise((resolve, reject) => {
          send
            .post('unregistered.php', {
              module: 'get_payment_yandex_pay',
              order_id: this.paymentData.idOrder,
              success_url: successURL,
              fail_url: failURL,
            })
            .then(response => resolve(response))
            .catch(error => reject(error))
        })
      }

      // http://localhost:8080/buyCourse/6183/selectTariff
      // selectTime
      // fillingProfile

      const successURL = window.location.href.split('?')[0] + `?type=oldPayYandex&payStatus=successfully&idPrice=${ this.paymentData.idPrice }&activeTypeTutor=${ this.paymentData.activeTypeTutor }&idCourses=${ this.paymentData.idCourse }&amount=${ this.paymentData.price }`;
      const failURL = window.location.href.split('?')[0] + '?type=oldPayYandex&payStatus=error';

      apiGetPayLink(successURL, failURL).then(response => {
        window.open(response.payment_url, '_self');
      });
    },

    // Результат оплаты через SBP
    SBPPayResult(data) {
      console.log('SBPPayResult', data);
      console.log('this.idSPBPay', this.idSPBPay);

      if (this.idSPBPay !== data.idOrder) return false;

      if (data.status === 1) this.successBuyCourse(data.idCourse);
      else this.createError('К сожалению, оплата через систему быстрых платежей не удалась')
    },

    // отобразить модальное окно с оплатой через СПБ
    showSPBPay() {
      this.showModalPaySPB = true;

      /** Получить изображение qr кода
       */
      let apiGetQR = () => {
        return new Promise((resolve, reject) => {
          send
            .post('unregistered.php', {
              module: 'get_payment_sbp',
              order_id: this.paymentData.idOrder,
            })
            .then(response => resolve(response))
            .catch(error => reject(error))
        })
      }

      /** Открыть модальное окно оплаты через CПБ
       * @param {String|Number} idSPB - id оплаты через СПБ
       * @param {String} qrImage - изображение QR кода
      * */
      let openModalSPBPay = (idSPB, qrImage) => {
        this.qrImage = qrImage;
        this.idSPBPay = idSPB;
      };

      apiGetQR().then(
        response => {
          openModalSPBPay(response.sbp_id, response.qr);
        },

        error => {
          if (error.response?.data?.error === 'tinkoff_api_error') this.openErrorModal('Ошибка при оплате через СПБ! Обратитесь к техническому специалисту')
        },
      )
    },

    // создает ошибку
    createError(text) {
      emitter.emit('openGlobalNotifications', {
        show: true,
        time: 4,
        text: text,
        type: 'error'
      });
    },

    // оплатить с карты
    cardPay() {
      let th = this;
      let mskSecondsTime = getMoscowTime().timeInSeconds;

      let count_month = null; // кол-во месяцев для оплаты
      let count = null; // количество занятий (если это первая оплата, то null или false или 0)
      let course_name = this.paymentData.courseName; // наименование курса
      let course_id = this.paymentData.idCourse; // id курса
      let tariff_name = this.paymentData.tariffName; // наименование тарифа
      let amount = this.paymentData.price; // сумма к оплате
      let teacher_type = (this.paymentData.activeTypeTutor === 'topTutor') ? (1) : (0); // тип репетитора (1 - топ, 0 - стандарт)
      let user_id = this.$store.state.auth.other.id;  //  id юзера
      let email = this.mail; // Email юзера
      let name = this.$store.state.auth.other.name; // имя юзера
      let vk_id = this.$store.state.auth.other.vk_id; //  ВК ID юзера
      let stock = this.paymentData.idStock; // ID пакета
      let packageName = this.paymentData.packageName ?? null;
      let enableSelectTeacher = ((this.paymentData.enableSelectTeacher !== undefined) && (this.paymentData.enableSelectTeacher !== null)) ? (this.paymentData.enableSelectTeacher) : (true);
      let is_first = true; // true - первая оплата, false - доплата
      let promo = null; // текст промокода
      let source = null;
      let telephone = null;
      let is_prepay = false; // является ли данный платеж доплатой
      let listCourses = [
        {
          id: course_id,
          idCourse: course_id,
          description: tariff_name,
          name: course_name,
        }
      ];
      let typeCourses = this.isSummerSchool ? 'ss' : this.$route.params.typePlatform;
      let orderId = this.paymentData.idOrder;

      if (localStorage.getItem('utmMark')) {
        source = JSON.parse(localStorage.getItem('utmMark'));
      }

      let manager = null;
      let action = null;
      let description = '';

      let funcSuccess = () => {
        th.successBuyCourse();
      }

      let funcError = (typeError) => {
        if (typeError === 'connect_error') {
          th.showModuleNotification = true;
          th.modalNotification.time = 6;
          th.modalNotification.text = 'Не удалось подключить платежный виджет, обратитесь к техническому специалисту';
          th.modalNotification.type = 'error';   // successfully / error
        } else {
          th.showModuleNotification = true;
          th.modalNotification.time = 6;
          th.modalNotification.text = 'Ошибка! Платёж не прошёл';
          th.modalNotification.type = 'error';   // successfully / error
        }
      }

      switch (this.$store.state.allCourses[course_id].type) {
        case 'pgk': // ПГК
          count_month = this.paymentData.countMonth;
          promo = this.getPromoDefault(mskSecondsTime, 'pgk');
          action = 'buy_semi_course';

          payPGKMethod(
            count,
            count_month,
            course_name,
            course_id,
            tariff_name,
            amount,
            teacher_type,
            user_id,
            email,
            name,
            vk_id,
            stock,
            is_first,
            promo,
            manager,
            source,
            action,
            funcSuccess,
            funcError
          );
          break;

        case 'ff': // Огненное итоговое
          description = 'Покупка огненного итогового. Тариф: ' + tariff_name;
          telephone = this.convertTelephone(this.telephone.value);

          payOrder(
            description,
            listCourses,
            typeCourses,
            orderId,
            user_id,
            email,
            name,
            vk_id,
            telephone,
            funcSuccess,
            funcError,
          )
          break;

        default: // ГК
          description = getDescription(listCourses, typeCourses);
          telephone = this.convertTelephone(this.telephone.value);

          payOrder(
            description,
            listCourses,
            typeCourses,
            orderId,
            user_id,
            email,
            name,
            vk_id,
            telephone,
            funcSuccess,
            funcError,
          )
      }
    },

    // преднастройка данных для функционала с рассрочкой
    presetInstallmentData() {
      let promo = null; // текст промокода
      let mskTime = new Date().toLocaleTimeString('ru-RU', {timeZone: 'Europe/Moscow'});
      let mskDate = new Date().toLocaleDateString('ru-RU', {timeZone: 'Europe/Moscow'});
      let mskTimeSplit = mskTime.split(':');  // 18:22:33
      let mskDateSplit = mskDate.split('.'); // 23.09.gk

      let mskSecondsTime = Number(new Date(mskDateSplit[2] + '-' + mskDateSplit[1] + '-' + mskDateSplit[0] + 'T' + mskTimeSplit[0] + ':' + mskTimeSplit[1] + ':' + mskTimeSplit[2] + '+03:00').getTime()) / 1000;

      let source = null;

      if (localStorage.getItem('utmMark')) {
        source = JSON.parse(localStorage.getItem('utmMark'));
      }

      switch (this.typePage) {
        case 'gk': // ГК
          promo = this.getPromoGK(mskSecondsTime);
          this.getInstallmentData(promo, source, 'gk');
          break;

        case 'ff':
          promo = this.getPromoDefault(mskSecondsTime);
          this.getInstallmentData(promo, source, 'ff');
          break;

        case 'pgk': // ГК
          promo = this.getPromoDefault(mskSecondsTime, 'pgk');
          this.getInstallmentData(promo, source, 'pgk');
          break;
      }
    },

    // получить промокод для огненного итогового
    getPromoDefault(mskSecondsTime, type = 'finalEssay') {
      if (
        (this.paymentData.timeEndPromoCode !== undefined) &&
        (mskSecondsTime >= this.paymentData.timeEndPromoCode)
      ) { // промокод просрочен
        this.showModuleNotification = true;
        this.modalNotification.time = 6;
        this.modalNotification.text = 'Ошибка! Срок действия промокода истек';
        this.modalNotification.type = 'error';   // successfully / error

        this.$emit("close", "promocode_time_end");
      } else if (
        (
          this.paymentData.promoCode !== null) &&
        (
          (this.paymentData.idTariffPromoCode === -1) ||
          (this.paymentData.idTariffPromoCode === this.paymentData.idStock) || (
            Array.isArray(this.paymentData.idTariffPromoCode) &&
            (this.paymentData.idTariffPromoCode.includes(this.paymentData.idStock))
          ) || (
            this.paymentData.prices && (this.paymentData.prices[this.paymentData.idStock] !== undefined)
          )
        )
      ) {
        return this.paymentData.promoCode;
      } else if (sessionStorage.getItem(type)) {
        let promoData = JSON.parse(sessionStorage.getItem(type));
        return (promoData && promoData.promo) ? (promoData.promo) : (null);
      }

      return null
    },

    // получить промокод для ГК
    getPromoGK(mskSecondsTime) {
      let promo, promoGK = null;

      if (
        (this.paymentData.timeEndPromoCode !== undefined) &&
        (mskSecondsTime >= this.paymentData.timeEndPromoCode)
      ) { // промокод просрочен
        this.showModuleNotification = true;
        this.modalNotification.time = 6;
        this.modalNotification.text = 'Ошибка! Срок действия промокода истек';
        this.modalNotification.type = 'error';   // successfully / error

        this.$emit("close", "promocode_time_end");
      } else if (
        (this.paymentData.promoCode !== null) &&
        (
          (this.paymentData.teacherType === -1) ||
          (this.paymentData.teacherType === undefined) ||
          ((this.paymentData.activeTypeTutor === 'standardTutor') && (this.paymentData.teacherType === 0)) ||
          ((this.paymentData.activeTypeTutor === 'topTutor') && (this.paymentData.teacherType === 1))
        ) && (
          (this.paymentData.idTariffPromoCode === -1) ||
          (this.paymentData.pricesStandard && (this.paymentData.pricesStandard[this.paymentData.idStock] !== undefined)) ||
          (this.paymentData.pricesTop && (this.paymentData.pricesTop[this.paymentData.idStock] !== undefined)) ||
          (this.paymentData.idTariffPromoCode === this.paymentData.idStock) ||
          (
            Array.isArray(this.paymentData.idTariffPromoCode) &&
            (this.paymentData.idTariffPromoCode.includes(this.paymentData.idStock))
          )
        )
      ) {
        promoGK = this.paymentData.promoCode;
      }

      if (this.paymentData.specialPromo && (this.paymentData.specialPromo.length > 0)) {
        promo = [];
        if (promoGK) promo.push(promoGK);
        promo.push(this.paymentData.specialPromo);
      } else {
        promo = promoGK
      }

      return promo
    },

    // получение данных для рассрочки
    getInstallmentData(promo, source, type) {
      let data;

      switch (type) {
        case 'gk': // годовой курс
          data = {
            module: 'tinkoff_create_order_buy_course_gk',
            course_id: this.paymentData.idCourse,
            amount: this.paymentData.price,
            teacher_type: (this.paymentData.activeTypeTutor === 'topTutor') ? (1) : (0),
            stock: this.paymentData.idStock,
            promo: promo,
            source: source,
            is_get_keys: true,
          };
          break;

        case 'ff': // огненное итоговое
          data = {
            module: 'tinkoff_create_order_buy_course_fe',
            course_id: this.paymentData.idCourse,
            amount: this.paymentData.price,
            stock: this.paymentData.idStock,
            promo: promo,
            source: source,
            is_get_keys: true,
          };
          break;

        case 'pgk': // огненное итоговое
          data = {
            module: 'tinkoff_create_order_buy_course_pgk',
            course_id: this.paymentData.idCourse,
            amount: this.paymentData.price,
            stock: this.paymentData.idStock,
            promo: promo,
            source: source,
            is_get_keys: true,
          };
          break;
      }

      send
        .post('payments.php', data)
        .then((response) => {
          console.log('получение ключей', response);
          this.installmentData.orderId = response.order_id;
          this.installmentData.list = [];

          let creditInfo;
          console.log('type', this.$store.state.allCourses[this.paymentData.idCourse].type);
          switch (this.$store.state.allCourses[this.paymentData.idCourse].type) {
            case 'pgk': // ПГК
              creditInfo = response.keys.credit_info.race;
              this.installmentData.showcaseId = response.keys.pgk.tinkoff.showcaseId;
              this.installmentData.shopId = response.keys.pgk.tinkoff.shopId;
              break;

            case 'gk': // ГК и ОИ
              creditInfo = response.keys.credit_info.gk;
              this.installmentData.showcaseId = response.keys.gk.tinkoff.showcaseId;
              this.installmentData.shopId = response.keys.gk.tinkoff.shopId;
              break;

            default:
              creditInfo = response.keys.credit_info;
              this.installmentData.showcaseId = response.keys.gk.tinkoff.showcaseId;
              this.installmentData.shopId = response.keys.gk.tinkoff.shopId;
          }

          if (creditInfo) {
            creditInfo.forEach((item, i) => {
              let sumPay = Math.floor(Number(this.paymentData.price) / item.term);

              this.installmentData.list.push({
                id: item.id,
                term: item.term,
                termText: item.term + ' ' + this.getWordDeclension(item.term, 'месяц'),
                sumPay: sumPay, // сумма ежемесячной оплаты
                sumPayString: String(sumPay).split(/(?=(?:...)*$)/).join(' '),
                promo: item.promo,
              });
            });
          }

          this.installmentData.list.sort((prev, next) => prev.term - next.term);
          this.installmentData.max = this.installmentData.list.length;
        })
        .catch((error) => {
          console.log('error get_keys');
          console.log(error)
          console.log(error.response)
        });
    },

    // получить склонение слова
    getWordDeclension(count, text) {
      if ((count >= 5) && (count <= 20)) return text + 'ев'
      if ((count % 10) === 1) return text
      if (((count % 10) >= 2) && ((count % 10) <= 4)) return text + 'а'
      return text + 'ев'
    },

    // оформить рассрочку
    buyInInstallments() {
      if (this.active_button.active) {
        let idFinalEssayCourse = this.$store.state.idFinalEssayCourse; // id для итогового сочинения
        let url = null,
          failURL = '',
          successURL = '',
          returnURL = '';

        if (process.env.NODE_ENV === 'production') url = `https://${location.hostname}/lk/gk`;
        else url = `https://ri-ege.ru/lk/gk`;

        switch (this.typePage) {
          case 'ff':
            failURL = url + `/buyCourse/${this.paymentData.idCourse}/selectTariff?status=reject`;
            successURL = url + `/buyCourse/${this.paymentData.idCourse}/fillingProfile?status=success`;
            returnURL = url + `/buyCourse/${this.paymentData.idCourse}/selectTariff`;
            break;

          case 'pgk': // ГК
            failURL = url + `/pgk/buyCourse/${this.paymentData.idCourse}/selectTariff?status=reject`;
            successURL = url + `/pgk/buyCourse/${this.paymentData.idCourse}/fillingProfile?status=success`;
            returnURL = url + `/pgk/buyCourse/${this.paymentData.idCourse}/selectTariff`;
            break;

          default:
            failURL = url + `/buyCourse/${this.paymentData.idCourse}/selectTariff?status=reject`;
            successURL = url + `/buyCourse/${this.paymentData.idCourse}/selectTime?status=success`;
            returnURL = url + `/buyCourse/${this.paymentData.idCourse}/selectTariff`;
        }

        const applicationData = { // данные заявки
          sum: this.installmentData.amount,
          items: [
            {
              name: this.paymentData.courseName,
              price: this.installmentData.amount,
              quantity: 1,
            }
          ],
          demoFlow: 'sms',
          promoCode: (this.installmentData.list) ? (this.installmentData.list[Number(this.installmentData.selectedMonth) - 1].promo) : (null),
          shopId: this.installmentData.shopId,
          showcaseId: this.installmentData.showcaseId,
          orderNumber: this.installmentData.orderId,
          failURL: failURL, // URL для возврата в случае неуспешного завершения заявки
          successURL: successURL, // URL для возврата в случае успешного завершения заявки,
          returnURL: returnURL, // URL для возврата в случае отмены заявки покупателем
        };

        if (this.$store.state.auth.other.is_tester) {
          tinkoff.createDemo(
            applicationData,
            {view: 'newTab'}
          )
        } else {
          tinkoff.create(
            applicationData,
            {view: 'newTab'}
          )
        }
      }
    },

    // события по рассрочке
    onTinkoffMessage(data) {
      switch (data.type) {
        case tinkoff.constants.SUCCESS:
          console.log('SUCCESS', data.meta.iframe.url);
          this.successBuyCourse();
          break;
        case tinkoff.constants.REJECT:
          console.log('REJECT', data.meta.iframe.url);

          this.showModuleNotification = true;
          this.modalNotification.time = 6;
          this.modalNotification.text = 'Ошибка! В заявке на оформление рассрочки было отказано';
          this.modalNotification.type = 'error';   // successfully / error
          break;
        case tinkoff.constants.CANCEL:
          console.log('CANCEL', data.meta.iframe.url);
          break;
        default:
          return;
      }

      tinkoff.methods.off(tinkoff.constants.SUCCESS, this.onTinkoffMessage);
      tinkoff.methods.off(tinkoff.constants.REJECT, this.onTinkoffMessage);
      tinkoff.methods.off(tinkoff.constants.CANCEL, this.onTinkoffMessage);
      data.meta.iframe.destroy();
    },

    // оплата курса прошла успешно
    successBuyCourse(idCourse = this.paymentData.idCourse) {
      let th = this;

      /*if (!th.$store.state.auth.other.is_accept_contract) { // если соглашение с перс. данными не принято
        th.applyPaymentAgreement();
      }*/

      emitter.emit('openGlobalNotifications', {
        show: true,
        time: 6,
        text: 'Оплата прошла успешно!',
        type: 'successfully'
      });
      localStorage.removeItem('utmMark');

      th.getDiscountData();

      setTimeout(() => {
        let data = {
          module: 'get_courses'
        };

        send
          .post('course.php', data)
          .then((response) => {
            console.log('get_courses');
            console.log(response);
            let countCourses = 0;
            let storePurchasedCourses = []; // купленные курсы

            if (this.isOldVersion) {
              countCourses = response.courses?.length ?? 0;
              response.courses?.forEach((item, i) => {
                if (item.is_buy_course) {
                  storePurchasedCourses.push({
                    id: item.id,
                    title: item.name,
                  });
                }
              });
            } else {
              response.product_list.forEach((item, i) => {
                item.courses.forEach((course, j) => {
                  countCourses += 1;
                  if (item.is_buy_course) {
                    storePurchasedCourses.push({
                      id: item.id,
                      title: item.name,
                    });
                  }
                })
              });
            }

            if (this.nextRoute && (this.nextRoute.length > 0)) {
              this.$router.push({name: this.nextRoute, params: {}});
              return;
            }

            switch (this.$store.state.allCourses[idCourse].type) {
              case 'pgk': // ПГК
                if (this.paymentData.idsTariffWithSelectTutor.includes(idCourse)) { // на данном тарифе доступен выбор репетитора
                  th.$router.push({
                    name: 'pgkBuySelectTime',
                    params: {
                      idCourse: idCourse
                    }
                  })
                } else {
                  th.$router.push({
                    name: 'pgkFillingProfile',
                    params: {
                      idCourse: idCourse
                    }
                  })
                }
                break;

              case 'ff': // Огненное итоговое
                th.$router.push({
                  name: 'FillingProfile',
                  params: {
                    idCourse: idCourse
                  }
                })
                break;

              default: // ГК
                if ((countCourses > 0) && (countCourses > storePurchasedCourses.length)) emitter.emit('openDiscountModal');

                if (th.$store.state.auth.other.is_open_select_teacher) th.$router.push({
                  name: 'buySelectTime',
                  params: {}
                })
                else th.$router.push({name: 'FillingProfile', params: {idCourse: idCourse}})
            }
          })
          .catch((error) => {
            console.log('error');
            console.log(error);
            console.log(error.response);
          })
      }, 2000)
    },

    // получить данные о скидке
    getDiscountData() {
      let data = {
        module: 'check_bonus_timer',
      };

      send
        .post('course.php', data)
        .then((response) => {
          console.log('check_bonus_timer');
          console.log(response);

          let storeData = {
            dataReceived: true,
            bonus_timer: response.bonus_timer,
          }

          this.$store.commit('setDataDiscountModal', storeData);
        })
        .catch((error) => {
          console.log('Error check_bonus_timer');
          console.log(error.response);
        })
    },

    // вернуться обратно на модальное окно с оплатой курса
    goBack() {
      this.openedModalInstallment = false;
    },

    // расчет позиции bar
    calcBarPosition() {
      let elem = document.getElementById('input-box__theme_range-custom');

      if (elem) {
        const elemWidth = elem.offsetWidth;
        let elemMargin = Number((elem.currentStyle || window.getComputedStyle(elem)).marginLeft.slice(0, -2));
        let currentPercentValue = ((Number(this.installmentData.selectedMonth) - this.installmentData.min) * 100) / (this.installmentData.max - this.installmentData.min);

        if (this.installmentData.min === this.installmentData.max) this.barPosition = elemMargin + ((50 * elemWidth) / 100) + 'px';
        else if (currentPercentValue === 100) this.barPosition = '100%';
        else this.barPosition = elemMargin + ((currentPercentValue * elemWidth) / 100) + 'px';
      } else {
        this.barPosition = '0%'
      }
    },

    /** Получить телефон
     * @param {String} telephone - номер телефона
     * @returns {String} в формате +7**********
     * **/
    convertTelephone(telephone) {
      let value = telephone.match( /\d+/g);

      return value.reduce((acc, item) => {
        return acc + (Number(item) === 7 ? '+' + item : item);
      }, '')
    },
  },

  computed: {
    // расчет позиции разделителя
    calcSeparatorPosition() {
      if (this.installmentData.min === this.installmentData.max) return '50%';
      return (((Number(this.installmentData.selectedMonth) - this.installmentData.min) * 100) / (this.installmentData.max - this.installmentData.min)) + '%';
    },

    // получить активный месяц рассрочки
    getMonthInstallment() {
      return (this.installmentData.list && (this.installmentData.list.length > 0)) ? (this.installmentData.list[Number(this.installmentData.selectedMonth) - 1].termText) : ('');
    },

    // получить сумму ежемесячного платежа
    getSumInstallment() {
      return (this.installmentData.list && (this.installmentData.list.length > 0)) ? (this.installmentData.list[Number(this.installmentData.selectedMonth) - 1].sumPayString) : ('');
    },

    // получить длину линии progressba'а
    getProgressLineLength() {
      let length = this.installmentData.list?.length;

      if (length) return ((length - 1) * 5) + 1;
      else return 1;
    },

    // Управление данными по рассрочкам
    installmentData: {
      get() {
        return this.installment
      },

      set(value) {
        this.$emit('update:installment', value);
      },
    },

    /** Проверяет корректность ввода телефона
     * @returns {Boolean}
     * */
    telephoneIsCorrect() {
      let tel = this.telephone.value.slice(-9);
      let checkLength = (value, length) => value && (value.length === length);
      let getPartsSeparator = (value, separator) => value.split(separator) || [];
      let checkCountSeparator = (value, separator) => {
        let parts = getPartsSeparator(value, separator);
        return checkLength(parts[0], 3) && checkLength(parts[1], 2) && checkLength(parts[2], 2);
      }

      return checkLength(tel, 9) && checkCountSeparator(tel, '-')
    },
  },


  components: {
    InputComponent,
    ModalNotification,
    PatternModalWindow,
    PaySPB,
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../style/styles_fonts";

$font_Geometria: Geometria, 'Geometria';

$color_background: #EBEBEB;
$color_purple: #F6F6FB;
$color_purple_1: #8C71FE;
$color_purple_2: #B1A1F2;
$color_purple_3: #f9f9fd;
$color_purple_4: #7B61EB;
$color_purple_bg_2: #F2F1FF;
$color_white: #FFFFFF;
$color_Gray: #ABABB2;
$color_Gray_1: #C5C5C9;
$color_Gray_2: #E2E2F6;
$color_Gray_4: #F2F2F2;
$color_cyanite_bg_2: #E3E8F4;
$color_cyanite_bg_4: #F6F8FC;
$color_black: #333333;
$color_red: #FF6597;
$color_cyen: #C0CADC;
$color_purple_5: #6F57D6;
$color_purple_6: #B1A1F2;
$color_green: #89CE54;
$path_img_checkbox1: '../../../../../public/img/check_contarct.svg';

$transition_fast: 0.5s ease;
$transition_medium: 0.5s ease;

.fade-enter-active, .fade-leave-active {
  transition: opacity ease .5s;
}

.fade-enter-from, .fade-leave-to {
  opacity: 0;
}

.main_info {
  display: flex;
  flex-direction: column;
  width: 780px;
}

.buy-component {
  display: flex;
  flex-direction: column;
  position: absolute;
  z-index: 21;
}

.text_block {
  font-family: $font_Geometria;
  font-style: normal;
  font-weight: 400;
  font-size: 17px;
  line-height: 130%;
  color: $color_black;
}

.input_grid {
  margin-top: 16px;
  display: grid;
  grid-template-columns: minmax(0, 1fr) 246px;
  grid-gap: 24px;
}

.inputBlock {
  .inputBlock_title {
    font-family: $font_Geometria;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    color: $color_Gray_1;
  }

  .inputBlock_input {
    display: flex;
    margin-top: 8px;
    position: relative;

    input {
      font: $font_Geometria;
      height: 54px;
      width: calc(100% - 82px);
      background-color: white;
      border: 1px solid rgba(0, 0, 0, 0.08);
      border-radius: 8px;
      color: $color_black;
      font-size: 16px;
      line-height: 140%;
      display: flex;
      align-items: center;
      padding: 0 60px 0 22px;
      font-weight: 400;
      font-style: normal;
      outline: none;
      transition: $transition_medium;

      &:hover {
        border: 1px solid $color_Gray_1
      }

      &:focus {
        border: 1px solid $color_purple_1
      }
    }

    .input__theme_disabled {
      background-color: $color_Gray_4;
      color: $color_black;

      &:hover {
        border: 1px solid rgba(0, 0, 0, 0.08);
        cursor: default;
      }
    }

    .input__theme_valid {
      background-color: #E7F5DD;
      border: 1px solid $color_green;
      cursor: default;

      &:hover {
        border: 1px solid $color_green;
        cursor: default;
      }
    }

    .input__theme_invalid {
      border: 1px solid $color_red;

      &:hover {
        border: 1px solid $color_red;
      }
    }

    .input_logo svg {
      transition: 0.5s ease;

      path {
        transition: 0.5s ease;
      }
    }

    input:focus + .input_logo svg path {
      fill: $color_purple_1;
    }

    input:hover:not(:focus) + .input_logo svg path {
      fill: $color_Gray;
    }

    input:hover:not(:disabled) + .input_logo svg path {
      fill: $color_Gray;
    }

    input::-webkit-input-placeholder { /* WebKit, Blink, Edge */
      font-family: $font_Geometria;
      color: $color_Gray_1;
    }

    input:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
      color: $color_Gray_1;
      font-family: $font_Geometria;

      opacity: 1;
    }

    input::-moz-placeholder { /* Mozilla Firefox 19+ */
      color: $color_Gray_1;
      font-family: $font_Geometria;

      opacity: 1;
    }

    input:-ms-input-placeholder { /* Internet Explorer 10-11 */
      color: $color_Gray_1;
      font-family: $font_Geometria;

    }

    input::-ms-input-placeholder { /* Microsoft Edge */
      color: $color_Gray_1;
      font-family: $font_Geometria;

    }

    input::placeholder { /* Most modern browsers support this now. */
      color: $color_Gray_1;
      font-family: $font_Geometria;
    }
  }

  .input_logo {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    right: 24px;
    width: 22px;
    height: 100%;
    cursor: text;
  }
}

.notifications {
  display: flex;
  position: absolute;
  z-index: 5;
  top: calc(64px + 10px);
  left: 0;
  width: calc(100% - 40px);
  min-height: calc(100% - 40px);
  background-color: $color_red;
  color: white;
  cursor: default;
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.1), 0 4px 4px rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  padding: 20px;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 23px;

  .notifications_square {
    position: absolute;
    background-color: $color_red;
    width: 14px;
    height: 14px;
    top: -7px;
    left: 28px;
    transform: rotate(45deg);
  }
}

.vk_button_block {
  display: flex;
  align-items: flex-end;
}

.vk_button {
  width: 100%;
  height: 56px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background: $color_purple_1;
  border-radius: 8px;
  outline: 0;
  border: 0;
  color: #fff;
  transition: $transition_medium;
}

.vk_button:hover {
  background: $color_purple_4;
}

.vk_button_text {
  font-family: $font_Geometria;
  margin-left: 10px;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  display: flex;
  align-items: center;
}

.check_contract {
  margin-top: 26px;
}

.check_contract_checkbox {
  position: absolute;
  z-index: -1;
  opacity: 0;
}

.check_contract_checkbox + label {
  position: relative;
  width: calc(85% - 35px);
  display: inline-flex;
  align-items: flex-start;
  user-select: none;
  cursor: pointer;
  font-family: $font_Geometria;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  color: $color_black;
  border-radius: 4px;
  transition: $transition_medium;
}

.check_contract_checkbox + label::before {
  content: '';
  position: relative;
  margin-right: 7px;
  display: inline-block;
  width: 18px;
  height: 18px;
  flex-shrink: 0;
  flex-grow: 0;
  border: 1px solid $color_Gray_1;
  border-radius: 4px;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 100% 100%;
  transition: $transition_medium;
}

.check_contract_checkbox:disabled + label {
  color: $color_Gray_1;
  background: #F9F9F9;
}

.check_contract_checkbox:disabled + label::before {
  border-color: $color_Gray_1;
}

.check_contract_checkbox:checked + label::before {
  border: 1px solid $color_purple_1;
  background-color: $color_purple_1;
  background-image: url($path_img_checkbox1);
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 90%;
}

.check_contract_checkbox:hover + label::before {
  border-color: $color_purple_1;
}

.button__theme_pay {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-top: 19px;
  width: 100%;
  height: 56px;
  cursor: pointer;
  background: $color_purple_1;
  border-radius: 8px;
  font-family: $font_Geometria;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: $color_white;
  outline: 0;
  padding: 0 24px 0 24px;
  border: 0;
  transition: $transition_medium;

  &:hover {
    background-color: $color_purple_4;
  }
}

#buy-course .button__theme_disable {
  background-color: $color_Gray_4;
  color: #ABABB2;
  outline: 0;
  cursor: default;

  &:hover {
    background-color: $color_Gray_4;
  }
}

.label_block {
  position: relative;
}

.text_label {
  margin-left: 8px;

  a {
    color: $color_purple_1;
    transition: $transition_medium;
    cursor: pointer;

    &:hover {
      color: $color_purple_4;
    }
  }
}

.block__theme_grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  grid-gap: 15px;
  margin-top: 8px;
}

.svg {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  svg path {
    transition: $transition_medium;
  }
}

.block__row {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.block__column {
  display: flex;
  flex-direction: column;
}

.inputBlock__theme_pays {
  margin-top: 24px;
}

.main_info .block__theme_card-container .block__theme_disabled {
  border-color: $color_cyanite_bg_2;
  background-color: $color_Gray_4;
  cursor: default;

  &:hover {
    border-color: $color_cyanite_bg_2;
  }
}

.block__theme_card-container {
  display: flex;
  flex-direction: row;
  position: relative;

  .block__theme_card {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 56px;
    padding: 0 13px;
    border: 1px solid $color_cyanite_bg_2;
    background-color: $color_cyanite_bg_4;
    border-radius: 8px;
    box-sizing: border-box;
    transition: $transition_medium;

    .svg__theme_logo svg {
      width: 28px;
      height: auto;

      path {
        fill: $color_purple_2;
      }
    }

    .text {
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 140%;
      margin-left: 10px;
    }

    .svg__theme_arrow {
      transition: $transition_medium;
    }
  }

  .block__theme_credit {
    cursor: pointer;

    &:hover {
      border-color: $color_purple_1;
    }
  }

  .block__theme_pay-list {
    cursor: pointer;

    &:hover {
      border-color: $color_purple_1;
    }

    .svg__theme_logo svg {
      width: 28px;
      height: auto;
    }
  }

  .block__theme_pay-list_active {
    border-radius: 8px 8px 8px 0;
    border-color: $color_purple_1;

    .svg__theme_arrow {
      transform: rotate(180deg);
    }
  }

  .list {
    display: flex;
    flex-direction: column;
    background-color: white;
    border: 1px solid $color_purple_1;
    box-shadow: 0px 6px 8px -6px rgba(24, 39, 75, 0.12), 0px 8px 16px -6px rgba(24, 39, 75, 0.08);
    border-radius: 0 0 8px 8px;
    padding: 8px 0;
    position: absolute;
    left: 0;
    top: 55px;
    z-index: 2;
    min-width: 290px;

    .elem {
      display: flex;
      flex-direction: row;
      align-items: center;
      height: 50px;
      transition: $transition_medium;
      cursor: pointer;
      padding: 0 14px;

      &:hover {
        background-color: $color_purple_bg_2;
      }

      .text {
        margin-left: 10px;
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 140%;
      }
    }

    .elem__disabled {
      background-color: $color_Gray_4;
      cursor: default;

      &:hover {
        background-color: $color_Gray_4;
      }
    }
  }
}

.installment_component {
  .text__h3 {
    font-style: normal;
    font-weight: 400;
    font-size: 17px;
    line-height: 140%;
  }

  .text__h4 {
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 140%;
  }

  .input-wrapper {
    display: flex;
    flex-direction: column;
    margin-top: 17px;
    border-radius: 8px;
    border: 1px solid $color_background;
    width: 100%;
  }

  .input-wrapper_header {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    height: 64px;

    .text__additional {
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 18px;
      color: $color_Gray;
      margin-bottom: 2px;
    }
  }

  .input-wrapper_border {
    width: 100%;
    height: 1px;
    background-color: $color_background;
  }

  .input-wrapper_main {
    display: flex;
    flex-direction: column;
    margin: 20px;
  }

  .list-values {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 100%;

    .item {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      width: 20px;
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 20px;
      transition: $transition_fast;
    }

    .item__purple {
      color: $color_purple_1;
    }
  }

  .list-values__center {
    display: flex;
    flex-direction: row;
    justify-content: center;
  }

  .input-wrapper_content {
    display: flex;
    flex-direction: column;
    position: relative;
    width: 100%;
    margin-top: 5px;

    .input-bar {
      display: flex;
      flex-direction: row;
      width: 100%;
      background-color: $color_purple_bg_2;
      border: 1px solid $color_Gray_2;
      border-radius: 4px;
      position: relative;
      height: 19px;
      box-sizing: border-box;
      overflow: hidden;

      .bar {
        display: flex;
        flex-direction: row;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        background-color: $color_purple_1;
        transition: $transition_fast;
      }

      .separator {
        display: none;
      }
    }

    .input-box__theme_range-hidden {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      z-index: 2;
      opacity: 0;

      input[type="range"] {
        width: 100%;
        height: 100%;
        cursor: pointer;
      }
    }

    .input-box__theme_disable input[type="range"] {
      cursor: default;
    }

    .input-box__theme_range-custom {
      display: flex;
      flex-direction: column;
      position: relative;
      margin: 8px 10px 0 10px;
    }

    .block__theme_separator {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      position: absolute;
      transition: $transition_fast;

      .separator_desktop {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
      }

      .separator_mobile {
        display: none;
      }

      svg {
        margin: 1px 0 0 -9px;
      }
    }

    .block__theme_range {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      height: 18px;

      .line {
        display: flex;
        flex-direction: row;
        height: 4px;
        width: 1px;
        background-color: $color_Gray_1;
      }

      .line__theme_large {
        height: 12px;
      }
    }
  }

  .management {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    margin-top: 24px;

    .button {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      height: 52px;
      padding: 0 24px;
      border-radius: 8px;
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 20px;
      cursor: pointer;
      transition: $transition_medium;

      &:not(:first-child) {
        margin-left: 20px;
      }
    }

    .button__theme_light-purple {
      background-color: $color_purple_bg_2;
      color: $color_purple_1;

      &:hover {
        background-color: $color_purple_1;
        color: white;
      }
    }

    .button__theme_purple {
      background-color: $color_purple_1;
      color: white;

      &:hover {
        background-color: $color_purple_4;
      }
    }
  }
}

@media all and (max-width: 1440px) {
  .main_info {
    width: 700px;
  }

  .text_block {
    font-size: 16px;
    line-height: 20px;
  }
  .input_grid {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 220px;
    grid-gap: 16px;
  }
  .inputBlock {
    .inputBlock_title {
      font-size: 13px;
      line-height: 16px;
    }

    .inputBlock_input {
      margin-top: 6px;

      input {
        height: 46px;
        width: calc(100% - 58px);
        border-radius: 6px;
        font-size: 15px;
        line-height: 19px;
        padding: 0 44px 0 14px;
      }

      .input_vk {
        font-size: 15px;
        line-height: 19px;
      }
    }
  }

  .vk_button {
    max-height: 48px;
    border-radius: 6px;

    svg {
      width: 26px;
      height: 26px;
    }
  }

  .button__theme_pay {
    font-size: 15px;
    line-height: 19px;
    height: 48px;
    border-radius: 6px;
  }

  .vk_button_text {
    margin-left: 8px;
    font-size: 15px;
    line-height: 19px;
  }
  .check_contract_checkbox + label {
    width: calc(95% - 35px);
    font-size: 14px;
    line-height: 18px;
  }

  .inputBlock__theme_pays {
    margin-top: 16px;
  }

  .block__theme_grid {
    grid-gap: 14px;
    margin-top: 6px;
  }

  .block__theme_card-container .block__theme_card {
    width: 100%;
    height: 48px;
    padding: 0 14px;
    border-radius: 6px;
  }

  .block__theme_card-container .block__theme_pay-list_active {
    border-radius: 6px 6px 0 0;
  }

  .block__theme_card-container .block__theme_card .text {
    font-size: 15px;
    line-height: 19px;
    margin-left: 8px;
  }

  .block__theme_card-container .block__theme_card .svg__theme_arrow svg {
    width: 20px;
    height: auto;
  }

  .block__theme_card-container .list {
    border-radius: 0 0 6px 6px;
    padding: 6px 0;
    top: 47px;
    min-width: 280px;
    width: 100%;
    box-sizing: border-box;
  }

  .block__theme_card-container .list .elem .text {
    font-size: 15px;
    line-height: 19px;
    margin-left: 8px;
  }

  .block__theme_card-container .list .elem {
    height: 46px;
  }

  .installment_component .text__h3 {
    font-size: 16px;
    line-height: 20px;
  }

  .installment_component .input-wrapper {
    margin-top: 16px;
  }

  .installment_component .input-wrapper_header {
    height: 58px;
  }

  .installment_component .input-wrapper_header .text__additional {
    font-style: normal;
    font-weight: 500;
    font-size: 13px;
    line-height: 16px;
  }

  .installment_component .text__h4 {
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 19px;
  }

  .installment_component .list-values .item {
    width: 18px;
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    line-height: 19px;
  }

  .installment_component .management {
    margin-top: 22px;
  }

  .installment_component .management .button {
    height: 48px;
    padding: 0 18px;
    border-radius: 6px;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
  }

  .installment_component .management .button:not(:first-child) {
    margin-left: 18px;
  }
}

@media all and (max-width: 1280px) {
  .vk_button {
    max-height: 48px;
    border-radius: 6px;

    svg {
      width: 24px;
      height: 24px;
    }
  }
  .vk_button_text {
    margin-left: 6px;
    font-size: 15px;
    line-height: 19px;
  }
  .check_contract_checkbox + label {
    width: calc(95% - 35px);
    font-size: 14px;
    line-height: 18px;
  }

  .main_info::-webkit-scrollbar {
    width: 3px;
  }

  .main_info::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0);
    border-radius: 2px 0 0 2px;
  }

  .main_info::-webkit-scrollbar-thumb {
    border-radius: 2px;
  }
}

@media all and (max-width: 1160px) {
  .block__theme_card-container .block__theme_credit {
    &:hover {
      border-color: $color_cyanite_bg_2;
    }
  }
}

@media all and (max-width: 960px) {
  .main_info {
    width: calc(100vw - 60px - 56px);
  }

  .vk_button {
    max-height: 48px;
    border-radius: 6px;

    svg {
      width: 24px;
      height: 24px;
    }
  }
  .vk_button_text {
    margin-left: 6px;
    font-size: 15px;
    line-height: 19px;
  }
  .check_contract_checkbox + label {
    width: calc(95% - 35px);
    font-size: 14px;
    line-height: 18px;
  }
}

@media all and (max-width: 700px) {
  .block__theme_grid {
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    grid-gap: 15px;
    margin-top: 8px;
  }
}

@media all and (max-width: 600px) {
  .vk_button_block__mobile_disable {
    display: none;
  }

  .main_info {
    width: auto;
  }
  .text_block {
    line-height: 140%;
  }

  .text_block {
    font-size: 15px;
    line-height: 19px;
  }

  .input_grid {
    margin-top: 16px;
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 16px;
  }
  .inputBlock {
    margin-top: 0;

    .inputBlock_title {
      font-size: 12px;
      line-height: 15px;
    }

    .inputBlock_input {
      margin-top: 6px;

      input {
        height: 44px;
        width: calc(100% - 58px);
        border-radius: 6px;
        font-size: 14px;
        line-height: 18px;
        padding: 0 44px 0 14px;
      }

      .input_vk {
        font-size: 15px;
        line-height: 19px;
      }
    }
  }

  .button__theme_pay {
    height: 46px;
    border-radius: 6px;
  }

  .vk_button {
    max-height: 46px;
    border-radius: 6px;

    svg {
      width: 26px;
      height: 26px;
    }
  }
  .vk_button_text {
    margin-left: 6px;
    font-size: 15px;
    line-height: 19px;
  }
  .check_contract_checkbox + label {
    width: 100%;
    font-size: 14px;
    line-height: 18px;
  }
  .button {
    width: 100%;
    justify-content: center;
  }
  .btn_pay {
    width: 100%;
    padding: 14px 24px 13px 24px;
  }

  .inputBlock__theme_pays {
    margin-top: 16px;
  }

  .block__theme_grid {
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    grid-gap: 8px;
    margin-top: 6px;
  }

  .block__theme_card-container .block__theme_card {
    height: 46px;
    padding: 0 14px;
  }

  .block__theme_card-container .block__theme_card .text {
    font-size: 14px;
    line-height: 18px;
    margin-left: 6px;
  }

  .block__theme_card-container .list {
    top: 45px;
    min-width: auto;
    padding: 4px 0;
  }

  .block__theme_card-container .list .elem .text {
    font-size: 14px;
    line-height: 18px;
    margin-left: 6px;
  }

  .block__theme_card-container .list .elem {
    height: 40px;
  }

  .installment_component .text__h3 {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
  }

  .installment_component .input-wrapper {
    margin-top: 16px;
    border-radius: 4px;
  }

  .installment_component .input-wrapper_header {
    padding: 0 14px;
    height: 56px;
  }

  .installment_component .input-wrapper_main {
    margin: 17px 14px 20px 14px;
  }

  .installment_component .input-wrapper_content .input-bar {
    border: 1px solid #E2E2F6;
    border-radius: 12px;
    height: 24px;
    box-sizing: border-box;
  }

  .installment_component .input-wrapper_content .block__theme_separator {
    top: -21px;
  }

  .installment_component .input-wrapper_content .block__theme_separator .separator_desktop {
    display: none;
  }

  .installment_component .input-wrapper_content .block__theme_separator .separator_mobile {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.2), 0px 0px 1px rgba(0, 0, 0, 0.1), 0px 0px 8px rgba(0, 0, 0, 0.05);
    border: 1px solid rgba(0, 0, 0, 0.08);
    transition: $transition_fast;
    position: absolute;
    background-color: white;
    box-sizing: border-box;
    border-radius: 50%;
  }

  .installment_component .management {
    display: flex;
    flex-direction: column;
    margin-top: 19px;
  }

  .installment_component .management .button {
    height: 42px;
    padding: 0;
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    width: 100%;
  }

  .installment_component .management .button:not(:first-child) {
    margin: 14px 0 0 0;
  }
}

</style>